<template>
  <action-dialog v-model="show" max-width="475" scrollable transition="scroll-y-transition" action="put" :url="`/exams/${editedItem.id}`" success-msg="تم حفظ التغييرات بنجاح" title="تعديل الامتحان" button-text="حفظ" :data="{...editedItem, starts_at: edited_starts_at ? toDateTimeString(edited_starts_at) : null, ends_at: edited_ends_at ? toDateTimeString(edited_ends_at) : null}" @reset="resetEditForm" @sync="syncData">
        <v-text-field v-model="editedItem.name" label="اسم الامتحان" placeholder="أدخل اسم الامتحان"></v-text-field>
        <v-select v-model="editedItem.type" label="نوع الامتحان" :items="[{text: 'امتحان', value: 'exam'}, {text: 'واجب', value: 'homework'}]"></v-select>
        <v-text-field v-model="editedItem.duration" type="number" min="1" suffix="دقيقة" label="وقت الامتحان (اختياري)" placeholder="اترك الحقل فارغاً ليكون الامتحان بلا وقت" hint="بعد مرور الوقت سيتم إنهاء الامتحان إجبارياً"></v-text-field>
        <v-text-field v-model="editedItem.pass_percentage" type="number" min="1" prefix="%" label="نسبة النجاح"></v-text-field>
        <v-text-field v-model="editedItem.question_mark" type="number" suffix="درجة" label="درجة السؤال الواحد" hint="الدرجة الافتراضية لكل اﻷسئلة لكن يمكنك تعديل درجة سؤال معين لاحقاً"></v-text-field>
        <v-autocomplete v-model="editedItem.category_id" clearable label="التصنيف (اختياري)" placeholder="اختر التصنيف" :items="categories"></v-autocomplete>
        <v-datetime-picker v-if="show" v-model="edited_starts_at" label="يبدأ في (اختياري)" placeholder="اﻵن" ok-text="تأكيد" clear-text="مسح" :timePickerProps="{'ampm-in-title': true, scrollable: true, color: 'primary', headerColor: 'primary'}" :datePickerProps="{min: today, locale: 'ar', color: 'primary', headerColor: 'primary'}" :text-field-props="{persistentHint: true, hint: 'اترك الحقل فارغاً ليتم السماح بالدخول من اﻵن', class: 'mb-2'}"> </v-datetime-picker>
        <v-datetime-picker v-if="show" v-model="edited_ends_at" label="ينتهي في (اختياري)" placeholder="لا ينتهي" ok-text="تأكيد" clear-text="مسح" :timePickerProps="{'ampm-in-title': true, scrollable: true, color: 'primary', headerColor: 'primary'}" :datePickerProps="{min: today, locale: 'ar', color: 'primary', headerColor: 'primary'}" :text-field-props="{persistentHint: true, hint: 'اترك الحقل فارغاً ليتم السماح بالدخول للامتحان دائماً', class: 'my-2'}"> </v-datetime-picker>
        <v-textarea v-model="editedItem.description" rows="3" no-resize label="(اختياري) وصف الامتحان" placeholder="أدخل وصف طويل للامتحان" class="mt-3"></v-textarea>

        <v-checkbox v-model="editedItem.show_result" label="عرض النتيجة بعد اﻹنتهاء" color="primary" persistent-hint hint="سيظهر للطالب نتيجته فوراً بعد إنهاء الامتحان"></v-checkbox>
        <v-checkbox v-model="editedItem.show_detailed_result" label="عرض نتيجة مفصلة واﻹجابات الصحيحة" color="primary" persistent-hint hint="سيظهر للطالب إجاباته الخاطئة واﻹجابة الصحيحة لكل سؤال"></v-checkbox>
        <v-checkbox v-model="editedItem.shuffled_questions" label="ترتيب اﻷسئلة عشوائياً" color="primary" persistent-hint hint="خلط اﻷسئلة بحيث يكون لكل طالب نموذج بترتيب أسئلة مختلف"></v-checkbox>
        <v-checkbox v-model="editedItem.shuffled_answers" label="ترتيب اﻹجابات عشوائياً" color="primary" persistent-hint hint="تظهر اﻹجابات بترتيب مختلف لكل طالب"></v-checkbox>
        <v-checkbox v-if="enableImageAnswers" v-model="editedItem.enable_images_answers" label="إجابات الصور للأسئلة المقالية" color="primary" persistent-hint hint="السماح للطالب برفع صورة كإجابة للأسئلة المقالية"></v-checkbox>
    </action-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        value: {},
        data: {},
        categories: {},
        noReset: {type: Boolean, default: false}
    },
    data(){
        const now = new Date();
        return {
            today: now.toISOString().substr(0, 10),

            show: false,
            edited_starts_at: '',
            edited_ends_at: '',

            editedItem: {
                id: null,
                name: '',
                type: '',
                duration: '',
                pass_percentage: '',
                question_mark: '',
                show_result: true,
                show_detailed_result: false,
                shuffled_questions: true,
                shuffled_answers: false,
                enable_images_answers: false,
                category_id: '',
                description: '',
            },
        }
    },
    computed: {
        ...GlobalComputed,
        enableImageAnswers(){
            return this.appData.enable_exam_images_answers;
        },
    },
    watch: {
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        },
        data(){
            this.setEditedItem();
        }
    },
    methods: {
        syncData(data){
            this.$emit('sync', data);
        },
        resetEditForm(){
            if (!this.noReset){
                Object.assign(this.editedItem, {
                    id: null,
                    name: '',
                    description: '',
                });
                this.edited_starts_at = '';
                this.edited_ends_at = '';
            }
        },
        setEditedItem(){
            const exam = this.data;
            if (exam){
                Object.assign(this.editedItem, exam);
                this.edited_starts_at = '';
                this.edited_ends_at = '';
                if (exam.starts_at_timestamp){
                    this.edited_starts_at = new Date(exam.starts_at_timestamp);
                }
                if (exam.ends_at_timestamp){
                    this.edited_ends_at = new Date(exam.ends_at_timestamp);
                }
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        this.setEditedItem();
    }
}
</script>

<style>

</style>
